import { Box, SxProps, Typography } from '@mui/material';
import Link from 'next/link';
import useTranslation from 'next-translate/useTranslation';
import { CSSProperties, FC } from 'react';

interface YearLinkProps {
    year: string;
    isNext?: boolean;
}

const imgArrowSx: CSSProperties = {
    width: '20px',
};

const imgArrowLeftSx: CSSProperties = {
    ...imgArrowSx,
    marginLeft: '8px',
};

const imgArrowRightSx: CSSProperties = {
    ...imgArrowSx,
    marginRight: '8px',
};

const paperSx: SxProps = {
    backgroundColor: 'grey.700',
    borderRadius: '6px',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    p: '12px',
};

const titleSx: SxProps = {
    alignItems: 'center',
    color: 'grey.100',
    display: 'flex',
    fontWeight: '600',
};

const YearLink: FC<YearLinkProps> = ({ year, isNext = false }) => {
    const { t } = useTranslation('sitemap');
    const justifyContent = isNext ? 'flex-end' : 'flex-start';

    return (
        <Link href={`/sitemap/decisions/${year}`}>
            <Box sx={paperSx}>
                <Typography
                    alignItems="center"
                    display="flex"
                    justifyContent={justifyContent}
                    sx={{ color: 'grey.300' }}
                    variant="body2"
                    gutterBottom
                >
                    {!isNext && (
                        <img
                            alt="arrow-left"
                            src="/assets/arrow_left_black.svg"
                            style={imgArrowRightSx}
                        />
                    )}
                    {year}
                    {isNext && (
                        <img
                            alt="arrow-right"
                            src="/assets/arrow_right_black.svg"
                            style={imgArrowLeftSx}
                        />
                    )}
                </Typography>
                <Typography sx={{ ...titleSx, justifyContent }} variant="body2">
                    <Box component="span">{t('previousNextYearLinks', { year })}</Box>
                </Typography>
            </Box>
        </Link>
    );
};

export default YearLink;
